export default __webpack_public_path__ + "static/media/pdficon.a3ac571b.svg";